import { call } from 'redux-saga/effects'
import { APIS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* summary<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.GET, APIS.LANDINGPAGE.SUMMARY, action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        action?.onError({
            message: e?.message || 'Failed to fetch summary data',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'summary', action: action?.type })
    }
}
export function* siteSettings<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const data = action.payload
        const resp = yield call(CallApi.GET, APIS.LANDINGPAGE.SITE_SETTINGS, data, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        action?.onError({
            message: e?.message || 'Failed to fetch site settings',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'siteSettings', action: action?.type })
    }
}
export function* contactUs<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const data = action.payload
        const resp = yield call(CallApi.POST, APIS.LANDINGPAGE.CONTACT_US, data)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError({
        //     message: e.message,
        //     status_code: 400,
        //     success: false,
        // })
        action?.onError({
            message: e?.message || 'Failed to submit contact form',
            status_code: e?.status || 400,
            success: false,
        })
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'contactUs', action: action?.type })
    }
}
